/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_End_TimeInputs */

const en_settings_billing_end_time = /** @type {(inputs: Settings_Billing_End_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ends at`)
};

const zh_settings_billing_end_time = /** @type {(inputs: Settings_Billing_End_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结束时间`)
};

/**
* | output |
* | --- |
* | "Ends at" |
*
* @param {Settings_Billing_End_TimeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_end_time = /** @type {((inputs?: Settings_Billing_End_TimeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_End_TimeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_end_time(inputs)
	return zh_settings_billing_end_time(inputs)
});
export { settings_billing_end_time as "settings.billing.end_time" }